<div class="reminder-datepicker-container">
    <mat-calendar-header></mat-calendar-header>
    <div class="one-quick-selection">
        <div class="one-quick-selection-title">Select reminder date</div>
        <mat-radio-group
            [formControl]="dateShortcut"
            (change)="radioChange($event)"
            aria-labelledby="example-date-picker-group-label"
            class="example-date-picker-radio-group"
        >
            <mat-radio-button
            class="example-radio-button"
            i18n-aria-label="@@datepicker.radio-today-example"
            value="7"
            data-test-id="quick-datepicker-component.today"
            [disabled]="dueDateDiff <= 7"
            >One week before due date
            </mat-radio-button>
            <mat-radio-button
            class="example-radio-button"
            i18n-aria-label="@@datepicker.radio-next-week-example"
            value="14"
            data-test-id="quick-datepicker-component.next-week"
            [disabled]="dueDateDiff <= 14"
            >Two weeks before due date
            </mat-radio-button>
        </mat-radio-group>
    </div>
</div>